<template lang="html">
  <div class="flude-container">
    <footer class="footer mt-5">
      <Emergency />
      <div class="footer-center py-4">
        <div class="container">
          <div class="row py-3">
            <div class="col-md-3">
              <div class="footer-center-item">
                <h4>HELPFUL LINK</h4>
                <a href="#!" class="mb-2">Search</a>
                <a href="#!" class="mb-2">information</a>
                <a href="#!" class="mb-2">Help</a>
                <a href="#!" class="mb-2">Privacy Policy</a>
                <a href="#!" class="mb-2">Shipping Details</a>
                <a href="#!" class="mb-2">Return policy</a>
              </div>
            </div>
            <div class="col-md-3">
              <div class="footer-center-item">
                <h4>USEFUL LINKS</h4>
                <a href="#!" class="mb-2">Corona Pandemic</a>
                <a href="#!" class="mb-2">Symptoms</a>
                <a href="#!" class="mb-2">Preventions</a>
                <a href="#!" class="mb-2">World Health Report</a>
                <a href="#!" class="mb-2">Directors Board</a>
                <a href="#!" class="mb-2">Member States</a>
              </div>
            </div>
            <div class="col-md-3">
              <div class="footer-center-item">
                <h4>Information</h4>
                <a href="#!" class="mb-2">WHO Website</a>
                <a href="#!" class="mb-2">CDC Website</a>
                <a href="#!" class="mb-2">NHS Website</a>
                <a href="#!" class="mb-2">Harvard Health</a>
                <a href="#!" class="mb-2">Covid info</a>
                <a href="#!" class="mb-2">History of Corona</a>
              </div>
            </div>
            <div class="col-md-3">
              <div class="footer-center-item">
                <h4>Contact Us</h4>
                <div class="row">
                  <div class="col-md-12">
                    <div class="footer-icon">
                      <div class="footer-icon-position">
                        <i class="fa fa-map-marker footer-icon-1"></i>
                        <p>Demo Address #8901 Marmora</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 py-3">
                    <div class="footer-icon">
                      <div class="footer-icon-position">
                        <i class="fa fa-phone footer-icon-2"></i>
                        <p class="pt-2">01155865821</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="footer-icon">
                      <div class="footer-icon-position">
                        <i class="fa fa-envelope footer-icon-3"></i>
                        <p>info@example.com</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hr"></div>
      <div class="container">
        <div class="footer-end row">
          <div class="col-xs-12 col-sm-4">
            <div class="social-media-icons">
              <div class="container">
                <ul>
                  <li class="fb"><a href="#!"></a></li>
                  <li class="tw"><a href="#!"></a></li>
                  <li class="googleplus"><a href="#!"></a></li>
                  <li class="rss"><a href="#!"></a></li>
                  <li class="pintrest"><a href="#!"></a></li>
                  <li class="linkedin"><a href="#!"></a></li>
                  <li class="youtube"><a href="#!"></a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-xs-12 coppyright">© 2021 SSD Co. All Rights Reserved.</div>
          <div class="col-xs-12 col-sm-4">
            <div class="payment-accept">
              <div class="container">
                <img src="images/payments/payment_1.png" alt="payment_img" />
                <img src="images/payments/payment_2.png" alt="payment_img" />
                <img src="images/payments/payment_3.png" alt="payment_img" />
                <img src="images/payments/payment_4.png" alt="payment_img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Start Button Scroll To Top-->
    <div class="scroll" id="scrollBtn"><i class="fa fa-angle-up fa-2x"></i></div>
    <!-- End Button Scroll To Top-->
  </div>
</template>

<script>
import Emergency from './Emergency.vue';
export default {
  name: 'Footer',
  components:{
    Emergency
  }
}
</script>

<style lang="css">
footer {
  background-color: #1f273c;
  padding-bottom: 20px;
}

.footer-center-item h4 {
  padding: 0 0 18px;
  font-size: 17px;
  margin-bottom: 5px;
  color: #2a81ea;
  font-weight: 600;
  font-family: "Barlow", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.footer-center-item a {
  color: #b7bcc8;
  display: block;
  text-decoration: none;
  transition: color 300ms ease-in-out 0s, background-color 300ms ease-in-out 0s, background-position 300ms ease-in-out 0s;
}

.footer-center-item a:hover {
  color: #2a81ea;
}

.footer-icon .footer-icon-position i {
  margin-top: 5px;
  color: #fff;
  font-size: 30px;
  display: inline-block;
}

.footer-icon .footer-icon-1::before {
  font-size: 18px;
  color: #b7bcc8;
  height: 45px;
  width: 45px;
  line-height: 42px;
  display: inline-block;
  font-style: normal;
  text-align: center;
  margin-right: 10px;
  border-radius: 30px;
  border-radius: 999px;
  margin-top: 0px;
  border: 2px #b7bcc8 dotted;
}

.footer-icon .footer-icon-2::before {
  font-size: 18px;
  color: #b7bcc8;
  height: 45px;
  width: 45px;
  line-height: 42px;
  display: inline-block;
  font-style: normal;
  text-align: center;
  margin-right: 10px;
  border-radius: 30px;
  border-radius: 999px;
  margin-top: 0px;
  border: 2px #b7bcc8 dotted;
}

.footer-icon .footer-icon-3::before {
  font-size: 18px;
  color: #b7bcc8;
  height: 45px;
  width: 45px;
  line-height: 42px;
  display: inline-block;
  font-style: normal;
  text-align: center;
  margin-right: 10px;
  border-radius: 30px;
  border-radius: 999px;
  margin-top: 0px;
  border: 2px #b7bcc8 dotted;
}

.footer-icon p {
  color: #fff;
  margin-left: 9px;
  margin-top: 8px;
}

.footer-icon-position {
  display: flex;
}

.footer-center {
  background-color: #151c2e;
}

.hr {
  width: 100%;
  clear: both;
  overflow: hidden;
  padding: 10px 0;
  border-top: 1px rgba(255,255,255,0.1) solid;
}

.footer-end {
  margin-right: 0;
}

.social-media-icons {
  float: left;
  margin-top: 11px;
}

.social-media-icons ul {
  float: left;
  margin: 0px;
  list-style: none;
  padding: 0px;
}

.social-media-icons ul li {
  margin: 0px 5px 0px 0px;
  display: inline-block;
}

footer ul li {
  list-style-type: none;
}

.social-media-icons a {
  transition: background 400ms ease-in-out;
}

.social-media-icons .fb a {
  background: #3C5B9B;
  font-size: 18px;
  border-radius: 3px;
  line-height: 35px;
  display: inline-block;
  width: 35px;
  height: 35px;
  color: #fff;
  text-align: center;
  padding: 0;
}
.social-media-icons .fb a::before {
  content: "\f09a";
  font-family: FontAwesome;
}

.social-media-icons .tw a {
  background: #359BED;
  font-size: 18px;
  border-radius: 3px;
  line-height: 35px;
  display: inline-block;
  width: 35px;
  height: 35px;
  color: #fff;
  text-align: center;
  padding: 0;
}
.social-media-icons .tw a::before {
  content: "\f099";
  font-family: FontAwesome;
}

.social-media-icons .googleplus a {
  background: #E33729;
  font-size: 18px;
  border-radius: 3px;
  line-height: 35px;
  display: inline-block;
  width: 35px;
  height: 35px;
  color: #fff;
  text-align: center;
  padding: 0;
}
.social-media-icons .googleplus a::before {
  content: "\f0d5";
  font-family: FontAwesome;
}

.social-media-icons .rss a {
  content: "\f09e";
  font-family: FontAwesome;
  background: #FD9F13;
  font-size: 18px;
  border-radius: 3px;
  line-height: 35px;
  display: inline-block;
  width: 35px;
  height: 35px;
  color: #fff;
  text-align: center;
  padding: 0;
}
.social-media-icons .rss a::before {
  content: "\f09e";
  font-family: FontAwesome;

}

.social-media-icons .pintrest a {
  content: "\f0d3";
  font-family: FontAwesome;
  background: #cb2027;
  font-size: 18px;
  border-radius: 3px;
  line-height: 35px;
  display: inline-block;
  width: 35px;
  height: 35px;
  color: #fff;
  text-align: center;
  padding: 0;
}
.social-media-icons .pintrest a::before {
  content: "\f0d3";
  font-family: FontAwesome;
}

.social-media-icons .linkedin a {
  content: "\f0e1";
  font-family: FontAwesome;
  background: #027ba5;
  font-size: 18px;
  border-radius: 3px;
  line-height: 35px;
  display: inline-block;
  width: 35px;
  height: 35px;
  color: #fff;
  text-align: center;
  padding: 0;
}
.social-media-icons .linkedin a::before {
  content: "\f0e1";
  font-family: FontAwesome;
}

.social-media-icons .youtube a {
  background: #F03434;
  font-size: 18px;
  border-radius: 3px;
  line-height: 35px;
  display: inline-block;
  width: 35px;
  height: 35px;
  color: #fff;
  text-align: center;
  padding: 0;
}
.social-media-icons .youtube a::before {
  content: "\f167";
  font-family: FontAwesome;
}

footer .coppyright {
  color: #b7bcc8;
  float: left;
}

.coppyright {
  color: #888;
  display: block;
  text-align: center;
  font-size: 13px;
  padding-top: 20px;
}

.payment-accept {
  color: #333333;
  font-size: 14px;
  margin: auto;
  overflow: hidden;
  float: right;
}

.payment-accept img {
  margin-right: 12px;
  margin-top: 11px;
}

.scroll {
  right: 20px;
  bottom: 20px;
  display: none;
  width: 40px;
  height: 40px;
  background-color: #f44a6a;
  color: #fff;
  border-radius: 4px;
  border: 2px solid transparent;
  text-align: center;
  position: fixed;
  z-index: 15;
  transition: 0.5s;
  cursor: pointer;
}

.scroll:hover {
  border: 2px solid #0080ff;
  background-color: transparent;
  color: #0080ff;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.scroll i {
  display: inline-block;
  line-height: 37px;
}

</style>
